import { useGetLimitationsQuery } from "@/shared/services";
import Icon from "@components/ui/icon";
import { cn } from "@lib/cn";
import { useAiImageStore } from "../store";

export const AiImageGenerateTrigger = ({
  handleGenerateImage,
}: {
  handleGenerateImage: () => void;
}) => {
  const { data: aiLimits } = useGetLimitationsQuery("image");
  const isLimitReached = !!aiLimits?.reached;
  const prompt = useAiImageStore((s) => s.prompt);

  return (
    <button
      aria-label="Generate"
      type="button"
      className={cn(
        "tw-size-8 tw-outline-none tw-rounded-full tw-group/trigger tw-shadow-sm tw-border tw-border-solid tw-border-primary-800 tw-flex tw-items-center tw-justify-center tw-bg-primary",
        "disabled:tw-bg-blue-200 disabled:tw-border-blue-300 disabled:tw-opacity-50",
      )}
      disabled={!prompt || isLimitReached}
      onClick={isLimitReached ? undefined : handleGenerateImage}
    >
      <Icon
        icon="ri-arrow-right-line"
        className="tw-text-white group-disabled/trigger:tw-text-blue-700"
      />
    </button>
  );
};
